import React, { memo, forwardRef } from "react";
const SvgNotasubset1 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9 20a1 1 0 100 2h7a8 8 0 100-16H9a1 1 0 100 2h7a6 6 0 010 12H9zm0 4a1 1 0 100 2h14a1 1 0 100-2H9z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNotasubset1.displayName = "SvgNotasubset1";
const MemoForwardRef = memo(SvgNotasubset1);
export default MemoForwardRef;
